import * as preact from "preact";

import readlangClient from "readlangClient";

// Types for props
type Props = {
  appRouter: any;
};

// Types for state
type State = {
  coupons?: {
    _id: string;
    createdTimestamp: number;
    redeemerUserID: string;
    name: string;
    token: string;
    redeemedDate: string;
  }[];
  amount: number;
  months: number;
  name: string;
};

const couponURL = (token: string) => `/coupon?token=${token}`;

// Bind generics to ExpandableProps and ExpandableState
export default class AdminCouponsView extends preact.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      amount: 1,
      months: 1,
      name: "gift",
    };

    this.fetchCouponInfo();
  }

  async fetchCouponInfo() {
    const coupons = (
      await readlangClient.request("GET", "/api/coupon/listAll", {})
    ).data.coupons;

    this.setState({
      coupons,
    });
  }

  render() {
    return (
      <div>
        <h1>
          <a href="/admin">Admin</a> - Coupons
        </h1>
        <div>
          <h2>Issue coupons</h2>
          <ul>
            <li>
              <label>
                Name:{" "}
                <input
                  type="text"
                  value={this.state.name}
                  style={{ maxWidth: 300 }}
                  onChange={(event) => {
                    this.setState({ name: event.currentTarget.value });
                  }}
                />
              </label>
            </li>
            <li>
              <label>
                Months:{" "}
                <input
                  type="number"
                  value={this.state.months}
                  onChange={(event) => {
                    this.setState({
                      months: parseInt(event.currentTarget.value),
                    });
                  }}
                />
              </label>
            </li>
            <li>
              <label>
                Amount:{" "}
                <input
                  type="number"
                  value={this.state.amount}
                  onChange={(event) => {
                    this.setState({
                      amount: parseInt(event.currentTarget.value, 10),
                    });
                  }}
                />
              </label>
            </li>
            <li>
              <button
                onClick={async () => {
                  await readlangClient.request("POST", "/api/coupon/issue", {
                    name: this.state.name,
                    months: this.state.months,
                    amount: this.state.amount,
                  });
                  await this.fetchCouponInfo();
                }}
              >
                Issue
              </button>
            </li>
          </ul>
        </div>
        {this.state.coupons !== undefined ? (
          this.state.coupons.length === 0 ? (
            "No coupons"
          ) : (
            <div>
              <table>
                <tr>
                  <th>Created</th>
                  <th>Name</th>
                  <th>Token</th>
                  <th>URL</th>
                  <th>Redeemer ID</th>
                  <th>Redeemed Date</th>
                </tr>
                {this.state.coupons.map((coupon) => (
                  <tr>
                    <td>
                      {new Date(coupon.createdTimestamp * 1000).toISOString()}
                    </td>
                    <td>{coupon.name}</td>
                    <td>
                      <a href={couponURL(coupon.token)}>{coupon.token}</a>
                    </td>
                    <td>{couponURL(coupon.token)}</td>
                    <td>{coupon.redeemerUserID ?? "-"}</td>
                    <td>
                      {coupon.redeemedDate
                        ? coupon.redeemedDate.substring(0, 10)
                        : "-"}
                    </td>
                  </tr>
                ))}
              </table>
            </div>
          )
        ) : (
          <div>Loading...</div>
        )}
      </div>
    );
  }
}
